module.exports = __webpack_public_path__ + "static/media/200watt.16f4279e.md";